﻿$.fn.dxCtrlGridEmailEnvoi = function custom_dxCtrlGridEmailEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridemailenvoi dx-ctrl");
        this.createInstance(new cdxCtrlGridEmailEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlGridEmailEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var _disableUpdateFunction = false
    option.bddCtrl.mAddFunctionOnModifiedItemData(["com_email_envoi"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            if (typeof itemData != 'undefined') {
                dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("com_email_envoi").id_table, itemData.id_com_email_envoi)
            } else {
                dxGrid.mUpdateData()
            }
        })

    var dxGrid = null
    this.mGetDxGrid = function () { return dxGrid }
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        //indefini = 0
        //boite_reception = 1
        //archive = 2
        //spam = 3
        //liste_grise = 4
        //non_delivre = 5
        //reponse_auto = 6
        //envoi_brouillon = 7
        //envoi_attente = 8
        //envoi_encours = 9
        //envoi_envoye = 10
        //envoi_erreur = 11
        //envoi_tracking = 12
        //envoi_attente_immediat = 13
        //envoi_annule = 14
        if (typeof option.noDataText == 'undefined') {
            option.noDataText = "Aucun email envoyé"
            if (typeof option.lstIdTypeClassement != 'undefined') {
                option.noDataText = ""
                option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                    if (option.lstIdTypeClassement.length < 3) {
                        switch (parseInt(idTypeClassement)) {
                            case 1:
                                option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en boite de réception";
                                break; //brouillon
                            case 2: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en archive"; break; //attente envoi
                            case 3: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en spam"; break; //en cours d'envoi
                            case 4: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email reçu en bounce"; break; //envoyé
                            case 5: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email de notification non délivré reçu"; break; //envoyé
                            case 6: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email de réponse automatique reçu"; break; //tracking
                            case 7: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email brouillon"; break; //brouillon
                            case 8: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email en attente"; break; //brouillon
                            case 9: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email en cours d'envoi"; break; //en cours d'envoi
                            case 10: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email envoyé"; break; //en cours d'envoi
                            case 11: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email en erreur"; break; //en cours d'envoi
                            case 12: option.noDataText += ((option.noDataText.length > 0) ? "<br/>" : "") + "Aucun email en tracking"; break; //tracking
                        }
                    }
                })
            }
        }


        var typeData = ""
        if (option.lstIdTypeClassement.contains(7)) {
            //brouillon
            typeData = "emailenvoibrouillon"
            if (typeof option.context_grid == 'undefined') option.context_grid = "gridemailenvoibrouillon"
        } else {
            //envoye
            typeData = "emailenvoienvoye"
            if (typeof option.context_grid == 'undefined') option.context_grid = "gridemailenvoienvoye"
        }

        if (typeof option.allowFilter == "undefined") option.allowFilter = true
        if (typeof option.showColumnHeaders == "undefined") option.showColumnHeaders = true
        if (typeof option.allowGroup == "undefined") option.allowGroup = true
        if (typeof option.allowCheck == "undefined") option.allowCheck = true
        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: option.noDataText,
            typeData: typeData,
            lstLstConditionBase: mGetLstLstConditionBase(),
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            onHoverDataGrid: option.onHoverDataGrid,
            lstTypeGrille: ["Détails", "Lignes"],
            itemTemplateGrille: function (container, dataTemplate, type, optionTemplate) {
                var objBase = null
                if (dataTemplate.id_table_key == 0) {
                    objBase = new cObjetFile(dataTemplate, option.bddCtrl)
                } else {
                    objBase = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataTemplate.id_table_key).nom) //, option.dataTemplateDisplay.id_key)
                }
                objBase.itemTemplateGrille(container, dataTemplate, type)
                //if (!option.isMailing) {
                getClasseurDataTournee({ bddCtrl: option.bddCtrl }).mInitDragClasseur(container.closest(".divtemplate"), dxGrid, "com_email_envoi", "", optionTemplate.dataGrid, function (lstElementDataGrid) {
                })
                //}
            },
            onClickDataGrid: option.onClickDataGrid,
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: option.allowFilter,
            allowLucene: true,
            allowCheck: option.allowCheck,
            allowDeleteInToolbar: option.allowDeleteInToolbar,
            showColumnHeaders: option.showColumnHeaders,
            allowGroup: option.allowGroup,
            onSelectionChanged: option.onSelectionChanged
        }).dxCtrlVirtualGrid("instance")
    }

    this.mSwitchCheck = function () { dxGrid.mSwitchCheck() }

    this.mUpdateSearchLucene = function (txtSearch) { dxGrid.mUpdateSearchLucene(txtSearch) }

    function mGetLstDataCompteEmail() {
        var lstDataCpteEmail = []
        if (typeof option.adresse_email != 'undefined') {
            if (option.adresse_email.toLowerCase() == "favori") {
                lstDataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) {
                    return option.bddCtrl.mGetArray("compte_email_utilisateur").filter(function (oo) {
                        return oo.id_utilisateur == option.bddCtrl.utiCourant.id_utilisateur && oo.id_compte_email == o.id_compte_email && oo.in_favori == 1
                    }).length > 0
                })
            } else {
                lstDataCpteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) {
                    return o.adresse_email == option.adresse_email
                })
            }
        }
        return lstDataCpteEmail
    }

    function mGetLstField() {
        var lst = []
        if (option.lstIdTypeClassement.contains(7)) {
            lst = lst.concat([{
                name: "dcr",
                dataField: "dcr",
                caption: "Date création",
                icon: "fas fa-clock",
                allowFilter: true,
                allowGrid: true,
                allowGrouping: true,
                allowSorting: true,
                groupIndex: 0,
                sortOrder: "desc",
                dataType: "date",
                filterProperty: {
                    filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
                },
                calculateGroupValue: function (rowData) {
                    return rowData.dcr.toGrpDate().id
                },
                groupCellTemplate: function (columnElement, options) {
                    var tot = 0
                    options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                    columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
                },
                filterLinkGrp: "dcr_tri"
            }, {
                name: "dcr_tri",
                dataField: "dcr_tri",
                allowGrid: true,
                visible: false
            }])
            if (parametre.isMobile) {
                var dataField = lst.filter(function (o) { return o.name == "dcr" })[0]
                delete dataField.groupIndex
                dataField.sortIndex = 0
            }
        } else {
            lst = lst.concat([{
                name: "date_envoi",
                dataField: "date_envoi",
                caption: "Date d'envoi",
                icon: "fas fa-clock",
                allowFilter: true,
                allowGrid: true,
                allowGrouping: true,
                allowSorting: true,
                groupIndex: 0,
                sortOrder: "desc",
                dataType: "date",
                filterProperty: {
                    filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
                },
                calculateGroupValue: function (rowData) {
                    return rowData.date_envoi.toGrpDate().id
                },
                groupCellTemplate: function (columnElement, options) {
                    var tot = 0
                    options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                    columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Envoi: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
                },
                filterLinkGrp: "date_envoi_tri"
            }, {
                name: "date_envoi_tri",
                dataField: "date_envoi_tri",
                allowGrid: true,
                visible: false
            }])

            if (parametre.isMobile) {
                var dataField = lst.filter(function (o) { return o.name == "date_envoi" })[0]
                delete dataField.groupIndex
                dataField.sortIndex = 0
            }
        }
        lst = lst.concat([{
            name: "email_expediteur",
            dataField: "email_expediteur",
            caption: "Email expéditeur",
            icon: "fas fa-at",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-at dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + options.displayValue + " (" + tot + ")")
            }
        }, {
            name: "taille_octet",
            dataField: "taille_octet",
            caption: "taille",
            icon: "fas fa-weight-hanging",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return Math.ceil(rowData.taille_octet / 1024 / 1024)
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = ""
                switch (options.key[0]) {
                    case 1: txt = "< 1Mo"; break;
                    default:
                        txt = "entre " + (options.key[0] - 1) + "Mo et " + options.key[0] + "Mo";
                        break;
                }
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-weight-hanging dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.taille_octet
            },
            calculateSortValue: function (rowData) {
                return rowData.taille_octet
            },
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">="],
                editorTemplate(conditionInfo, itemElement) {
                    var value = ""
                    if (conditionInfo.value == null) { value = 1024 * 1024; }
                    else { value = conditionInfo.value }
                    conditionInfo.setValue(value);

                    if (value >= 1024) {
                        if (value >= 1024 * 1024) {
                            if (value >= 1024 * 1024 * 1024) {
                                value = value / 1024 / 1024 / 1024 + "|Go"
                            } else {
                                value = value / 1024 / 1024 + "|Mo"
                            }
                        } else {
                            value = value / 1024 + "|Ko"
                        }
                    } else {
                        value = value + "|o"
                    }

                    var $Div = $("<div class='ctrlinfilterbuilder'/>").appendTo(itemElement)
                    var $Table = $("<table/>").appendTo($Div)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td/>").appendTo($Tr)
                    var dxTaille = $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlSaisieTailleFichier({
                        min: 0,
                        width: 60,
                        isFloat: false,
                        noNull: true,
                        value: value,
                        onValueChanged: function (e) {
                            if (!e.value.endsWith("|o")) {
                                if (!e.value.endsWith("|Ko")) {
                                    if (!e.value.endsWith("|Mo")) {
                                        conditionInfo.setValue(parseInt(e.value.replace("|Go", "")) * 1024 * 1024 * 1024);
                                    } else {
                                        conditionInfo.setValue(parseInt(e.value.replace("|Mo", "")) * 1024 * 1024);
                                    }
                                } else {
                                    conditionInfo.setValue(parseInt(e.value.replace("|Ko", "")) * 1024);
                                }
                            } else {
                                conditionInfo.setValue(parseInt(e.value.replace("|o", "")));
                            }

                        }
                    }).dxCtrlSaisieTailleFichier("instance")
                    var $Td = $("<td/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-check",
                        onClick: function (e) {
                            conditionInfo.closeEditor()
                        }
                    })
                },
                customizeText: function (fieldInfo) {
                    if (fieldInfo.value >= 1024) {
                        if (fieldInfo.value >= 1024 * 1024) {
                            if (fieldInfo.value >= 1024 * 1024 * 1024) {
                                return fieldInfo.value / 1024 / 1024 / 1024 + " Go"
                            } else {
                                return fieldInfo.value / 1024 / 1024 + " Mo"
                            }
                        } else {
                            return fieldInfo.value / 1024 + " Ko"
                        }
                    } else {
                        return fieldInfo.value + " o"
                    }
                },
                //calculateFilterExpression(filterValue, field) {
                //    //["o", "Ko", "Mo", "Go"],
                //    return filterValue.split("|")[0] * ((filterValue.split("|")[1] == "o") ? 1 : ((filterValue.split("|")[1] == "Ko") ? 1024 : ((filterValue.split("|")[1] == "Mo") ? 1024*1024 : 1024*1024*1024)))
                //}
            }
        }, {
            name: "nb_fichier_joint",
            dataField: "nb_fichier_joint",
            caption: "Nbre fichier joint",
            icon: "fas fa-paperclip",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-paperclip dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.displayValue + " fichier" + ((tot > 1) ? "s" : "") + " (" + tot + ")")
            }
        }, {
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + txt + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "presentation_mailing",
            dataField: "presentation_mailing",
            caption: "Mailing",
            allowFilter: true,
            allowGrid: false,
            dataType: "number"
        }, {
            name: "objet",
            dataField: "objet",
            caption: "Objet",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "body_txt",
            dataField: "body_txt",
            caption: "Corps du mail",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "nom_usuel_expediteur",
            dataField: "nom_usuel_expediteur",
            caption: "Nom usuel expéditeur",
            allowFilter: true,
            allowGrid: false,
            dataType: "string"
        }, {
            name: "id_compte_email",
            dataField: "id_compte_email",
            caption: "id_compte_email",
            allowFilter: false,
            allowGrid: false,
            dataType: "number"
        }])

        lst.push({
            name: "tx_vue",
            dataField: "tx_vue",
            caption: "Tx vue",
            icon: "fas fa-eye",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            hint: "Taux de vue",
            calculateGroupValue: function (rowData) {
                return rowData.tx_vue
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Taux de vue: " + options.displayValue + "% (" + tot + ")")
            },
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">="],
                editorTemplate(conditionInfo, itemElement) {
                    var value = 50
                    if (conditionInfo.value != null) { value = conditionInfo.value }
                    $("<div class='ctrlinfilterbuilder'/>").appendTo(itemElement).dxCtrlNumberBox({
                        width: 150,
                        value: value,
                        min: 0,
                        max: 100,
                        buttonLeftRight: true,
                        desactiveTimeout: true,
                        onValueChanged: function (e) {
                            conditionInfo.setValue(((e.value == null) ? 50 : e.value));
                        }
                    })
                },
                customizeText: function (fieldInfo) {
                    return fieldInfo.value + "%"
                }
            }
        })
        lst.push({
            name: "tx_click",
            dataField: "tx_click",
            caption: "Tx click",
            icon: "fas fa-arrow-pointer",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            hint: "Taux de click",
            calculateGroupValue: function (rowData) {
                return rowData.tx_click
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Taux de click: " + options.displayValue + "% (" + tot + ")")
            },
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">="],
                editorTemplate(conditionInfo, itemElement) {
                    var value = 50
                    if (conditionInfo.value != null) { value = conditionInfo.value }
                    $("<div class='ctrlinfilterbuilder'/>").appendTo(itemElement).dxCtrlNumberBox({
                        width: 150,
                        value: value,
                        min: 0,
                        max: 100,
                        buttonLeftRight: true,
                        desactiveTimeout: true,
                        onValueChanged: function (e) {
                            conditionInfo.setValue(((e.value == null) ? 50 : e.value));
                        }
                    })
                },
                customizeText: function (fieldInfo) {
                    return fieldInfo.value + "%"
                }
            }
        })
        lst.push({
            name: "tx_reactivite",
            dataField: "tx_reactivite",
            caption: "Tx réactivité",
            icon: "fas fa-face-meh-blank",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            hint: "Taux de réactivité",
            calculateGroupValue: function (rowData) {
                return rowData.tx_click
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-face-meh-blank dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Taux de réactivité: " + options.displayValue + "% (" + tot + ")")
            },
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">="],
                editorTemplate(conditionInfo, itemElement) {
                    var value = 50
                    if (conditionInfo.value != null) { value = conditionInfo.value }
                    $("<div class='ctrlinfilterbuilder'/>").appendTo(itemElement).dxCtrlNumberBox({
                        width: 150,
                        value: value,
                        min: 0,
                        max: 100,
                        buttonLeftRight: true,
                        desactiveTimeout: true,
                        onValueChanged: function (e) {
                            conditionInfo.setValue(((e.value == null) ? 50 : e.value));
                        }
                    })
                },
                customizeText: function (fieldInfo) {
                    return fieldInfo.value + "%"
                }
            }
        })
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []


        if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-envelope",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouvel email",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-square-envelope",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouvel emailing",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_email_envoi").objetMetier.mShowNewEmail(true)
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-envelope-open-text",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            icon3: "fas fa-boxes",
            //            opacityIcone3: "0.7",
            //            colorIcone3: theme.color,
            //            leftIcone3: true,
            //            txtTooltip: "Nouveau document email dans la box",
            //            onClick: function (e) {
            //                (new cObjetFichierEmlzMetier(null, option.bddCtrl)).mShowNewDocumentEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            ////items.push({
            ////    location: 'before',
            ////    template: function (itemData, itemIndex, itemElement) {
            ////        dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            ////            icon: "fas fa-bars",
            ////            onClick: function (e) {
            ////                mShowBtPlus(e.component.element())
            ////            }
            ////        }).dxCtrlButton("instance")
            ////    }
            ////})
        }

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        var confidentiel = dataTemplate.confidentiel
        if (confidentiel == null) {
            var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == dataTemplate.id_compte_email })[0]
            confidentiel = ((typeof dataCompteEmail == 'undefined') ? "0" : dataCompteEmail.confidentiel)
        }

        if (option.bddCtrl.baseAppli.para.email.use_email_envoi_confidentiel) {
            items.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                options: {
                    icon: ((confidentiel == "0") ? 'fas fa-lock-open' : 'fas fa-lock'),
                    elementAttr: { class: "dx-button-grille-ligne" },
                    hint: ((confidentiel == "0") ? 'Cet email est publique.<br/>Cliquer pour le rendre confidentiel' : 'Cet email est confidentiel.<br/>Cliquer pour le rendre publique'),
                    focusStateEnabled: false,
                    text: ((confidentiel == "0") ? 'Email publique' : 'Email confidentiel'),
                    //hint: ((confidentiel == "0") ? 'Email publique' : 'Email confidentiel'),
                    onClick(e) {
                        if (typeof e != 'undefined') e.event.stopPropagation();
                        var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                        obj.data.confidentiel = ((confidentiel == "0") ? "1" : "0")
                        dataTemplate.confidentiel = obj.data.confidentiel
                        e.component.option("icon", ((dataTemplate.confidentiel == "0") ? 'fas fa-lock-open' : 'fas fa-lock'))
                        if (typeof e.element[0].tt != 'undefined')  e.element[0].tt.remove()
                        e.component.option("hint", ((dataTemplate.confidentiel == "0") ? 'Cet email est publique.<br/>Cliquer pour le rendre confidentiel' : 'Cet email est confidentiel.<br/>Cliquer pour le rendre publique'))
                        if (typeof e.element[0].t != 'undefined') e.element[0].t = e.component.option("hint")
                        e.element.find(".fas").css("color", ((dataTemplate.confidentiel == "0") ? 'green' : 'red'))
                        _disableUpdateFunction = true
                        obj.mSaveChamp("confidentiel")
                        mNotify("Votre message est mainteannt " + (dataTemplate.confidentiel == "0" ? 'publique' : 'confidentiel') + " dans " + parametre.nom, "success", 3000)
                    },
                    onContentReady: function (e) {
                        e.element.find(".fas").css("color", ((dataTemplate.confidentiel == "0") ? 'green' : 'red'))
                    }
                },
            })
        }



        //if (option.lstIdTypeClassement.contains(8)) {
        //    //envoi en attente
        //    items.push({
        //        location: 'before',
        //        widget: 'dxButton',
        //        showText: "inMenu",
        //        mobile: {
        //            index: 0,
        //            color: "green",
        //            position: "right"
        //        },
        //        options: {
        //            icon: 'fas fa-paper-plane',
        //            elementAttr: { class: "dx-button-grille-ligne" },
        //            focusStateEnabled: false,
        //            text: "Envoyer immédiatement",
        //            hint: "Envoyer votre email immédiatement",
        //            onClick(e) {
        //                if (typeof e != 'undefined') e.event.stopPropagation();
        //                var obj = option.bddCtrl.getObjet("com_email_envoi", dataGrid.id)
        //                obj.data.id_type_classement = 9
        //                obj.mSaveChamp("id_type_classement")
        //            }
        //        },
        //    })
        //} else {
        //autre
        if (option.bddCtrl.baseAppli.para.email.has_reception_email) {
            items.push({
                location: 'before',
                widget: 'dxButton',
                showText: "inMenu",
                mobile: {
                    index: 0,
                    color: "green",
                    position: "right"
                },
                options: {
                    icon: 'fas fa-share',
                    focusStateEnabled: false,
                    text: "Transférer",
                    hint: "Transférer",
                    elementAttr: { class: "dx-button-grille-ligne" },
                    onClick(e) {
                        if (typeof e != 'undefined') e.event.stopPropagation();
                        option.bddCtrl.getObjet("com_email_envoi", dataGrid.id).objetMetier.mShowTransfere()
                    }
                },
            })
        }
        //}

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            mobile: {
                index: 0,
                color: "red",
                position: "left"
            },
            options: {
                icon: "fas fa-trash-alt",
                focusStateEnabled: false,
                text: "Corbeille",
                hint: "Corbeille",
                elementAttr: { class: "dx-button-grille-ligne" },
                onClick(e) {
                    if (typeof e != 'undefined') e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })

        toolbar.option("items", items)
    }

    function mGetLstLstConditionBase() {
        var lstConditionBase = []
        if (typeof option.lstIdTypeClassement != 'undefined' && option.lstIdTypeClassement.length > 0) {
            var lstId = []
            option.lstIdTypeClassement.forEach(function (idTypeClassement) {
                lstId.push({ value: idTypeClassement })
            })
            lstConditionBase.push({ nom_champ: "id_type_classement", ope: "parmi", valeur: lstId })
        }
        var lstCompteEmail = mGetLstDataCompteEmail()
        if (lstCompteEmail.length > 0) {
            var lstId = []
            lstCompteEmail.forEach(function (cptEmail) {
                lstId.push({ value: cptEmail.id_compte_email })
            })
            lstConditionBase.push({ nom_champ: "id_compte_email", ope: "parmi", valeur: lstId })
        }

        if (typeof option.lstLstConditionBase != 'undefined' && option.lstLstConditionBase.length > 0) {
            var newLstLstConditionBase = []
            var lstLstConditionBaseOption = JSON.parse(JSON.stringify(option.lstLstConditionBase))
            lstLstConditionBaseOption.forEach(function (lstConditionBaseOption) {
                newLstLstConditionBase.push(lstConditionBase.concat(lstConditionBaseOption))
            })
            return newLstLstConditionBase
        } else {
            return [lstConditionBase]
        }
    }

    this.mReloadData = function () { dxGrid.mReloadData(true) }

    this.element = function () { return container }

    mConstruit();
}